import React, {FC, useRef} from "react"
import IconButton from "@irati/ui/src/Button/IconButton"
import {IconTypes} from "@irati/ui/src/Icon"
import RewardsModal from "@irati-web/wallet/src/components/RewardsModal"

const RewardsTriggerModal: FC = () => {
  const treatInformationModal = useRef(null)
  const handleModal = () => treatInformationModal?.current?.show()

  return (
    <div>
      <IconButton onClick={handleModal} icon={IconTypes.circleQuestion} extraLarge />
      <RewardsModal ref={treatInformationModal} />
    </div>
  )
}

export default RewardsTriggerModal
